import { render } from "./StudentFAQs.vue?vue&type=template&id=5b8e9ee5"
import script from "./StudentFAQs.vue?vue&type=script&lang=js"
export * from "./StudentFAQs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__